import Header from "../Components/Header/Header";
import { useAuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";
import Footer from "../Components/Footer/Footer";

const PaymentSuccess = () =>{
    const { user } = useAuthContext();
    let userName;
    if(user !=undefined)
    userName = user.firstName ? user.firstName : user.username;

    return(
        <div className="common-bg payment-status-page success-page">
            <div className="container">
                <Header title ={`Hello ${userName}`} />
                <div className="padding30"></div>
                <div className="content-wrap white-bg">
                    <div className="content-wrap-inner subscription-form status-wrap">
                        <div className="head-title">Payment Successful</div>
                        <p className="sub-title-text mb---20">Your subscription payment went through successfully.</p>
                        <div className="subscription-item">
                            <div><span>Status :</span> Active</div>
                            <div><span>Next step :</span> View orders and subscription from dashboard.</div>
                        </div>
                        <div className="thankyou-links mt---20">
                            <Link to="/dashboard"><button className="theme-btn">Go to dashboard</button></Link>
                            <Link to="/"><button className="theme-btn">Go to home</button></Link>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );
}
export default PaymentSuccess;
